var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHammerWar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.75 32.5L224 52.875V16C224 7.125 216.875 0 208 0H176C167.125 0 160 7.125 160 16V52.875L37.25 32.5C17.75 29.25 0 44.25 0 64V256C0 275.75 17.75 290.75 37.25 287.5L192 261.75L346.75 287.5C366.25 290.75 384 275.75 384 256V64C384 44.25 366.25 29.25 346.75 32.5ZM160 299.5V496C160 504.875 167.125 512 176 512H208C216.875 512 224 504.875 224 496V299.5L192 294.25L160 299.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerWar);
export default __webpack_public_path__ + "static/media/hammer-war.b9f577349808db614166225a4fc8ea6a.svg";
export { ForwardRef as ReactComponent };